import React, { useState } from "react";
import { Modal, Input, Button, List, message, Tag } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import authApi from "../../../api/authApi";

/**
 * Modal tìm 1 user hiện có (theo ID hoặc email) để nâng lên CTV.
 * Chọn user -> gọi onSelect(user) để parent mở modal phân quyền.
 */
function AddModModal({ open, onClose, onSelect }) {
    const [keyword, setKeyword] = useState("");
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState([]);

    const search = async () => {
        const kw = keyword.trim();
        if (!kw) return;
        setLoading(true);
        try {
            // Số thuần -> tìm theo userId, ngược lại theo email.
            const query = /^\d+$/.test(kw) ? `userId=${kw}` : `email=${encodeURIComponent(kw)}`;
            const { data } = await authApi.getAllUser(`${query}&limit=20`);
            setResults(data.users || []);
            if (!data.users?.length) message.info("Không tìm thấy user phù hợp");
        } catch {
            message.error("Tìm kiếm thất bại");
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setKeyword("");
        setResults([]);
        onClose?.();
    };

    return (
        <Modal open={open} title="Thêm CTV / Mod" onCancel={handleClose} footer={null} width={540}>
            <div className="flex gap-2 mb-3">
                <Input
                    placeholder="Nhập User ID hoặc email"
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    onPressEnter={search}
                    allowClear
                    prefix={<FontAwesomeIcon icon={faSearch} className="text-content-3 mr-1" />}
                />
                <Button type="primary" loading={loading} onClick={search}>
                    Tìm
                </Button>
            </div>

            <List
                size="small"
                dataSource={results}
                locale={{ emptyText: "Nhập ID/email rồi bấm Tìm" }}
                renderItem={(u) => (
                    <List.Item
                        actions={[
                            <Button
                                key="pick"
                                type="link"
                                onClick={() =>
                                    onSelect?.({
                                        id: u.userId,
                                        name: u.name,
                                        email: u.email,
                                        role: u.role,
                                        permissions: u.permissions,
                                    })
                                }
                            >
                                Chọn
                            </Button>,
                        ]}
                    >
                        <List.Item.Meta
                            title={
                                <span>
                                    #{u.userId} — {u.name}{" "}
                                    {u.role === "admin" && <Tag color="volcano">Admin</Tag>}
                                    {u.role === "mod" && <Tag color="blue">CTV</Tag>}
                                </span>
                            }
                            description={<span className="text-xs text-content-3">{u.email}</span>}
                        />
                    </List.Item>
                )}
            />
        </Modal>
    );
}

export default AddModModal;
